import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "../axiosBaseQuery";
import { IDemandPayload } from '../../interface/IDemand';

export const accuracyDeepDiveApi = createApi({
  reducerPath: 'accuracyDeepDiveApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
   accuracyDeepDiveApiDropDownFilter: builder.mutation({
      query: (payload: IDemandPayload) => ({
        url: "/forecastOverViewDropDownFilter",
        method: 'POST',
        data: payload,
      }),
    }),

    accuracyDeepDiveApiGraphData: builder.mutation({
      query: (payload: IDemandPayload) => ({
        url: "/getAccuracyDeepDive",
        method: 'POST',
        data: payload,
      }),
    }),

  }),
});

export const {
  useAccuracyDeepDiveApiDropDownFilterMutation,
  useAccuracyDeepDiveApiGraphDataMutation
} = accuracyDeepDiveApi;
